export default function ViewIcon() {
  return (
    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.0375 5.20899C0.9875 5.07429 0.9875 4.92611 1.0375 4.79141C1.5245 3.61058 2.35114 2.60094 3.41264 1.8905C4.47414 1.18005 5.72269 0.800781 7 0.800781C8.27731 0.800781 9.52586 1.18005 10.5874 1.8905C11.6489 2.60094 12.4755 3.61058 12.9625 4.79141C13.0125 4.92611 13.0125 5.07429 12.9625 5.20899C12.4755 6.38982 11.6489 7.39945 10.5874 8.1099C9.52586 8.82035 8.27731 9.19962 7 9.19962C5.72269 9.19962 4.47414 8.82035 3.41264 8.1099C2.35114 7.39945 1.5245 6.38982 1.0375 5.20899Z"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 6.80011C7.99406 6.80011 8.79991 5.99426 8.79991 5.0002C8.79991 4.00614 7.99406 3.20029 7 3.20029C6.00594 3.20029 5.20009 4.00614 5.20009 5.0002C5.20009 5.99426 6.00594 6.80011 7 6.80011Z"
        stroke="#4F4F4F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
